function SvgComponent({ fillColor = '#0CF389', color = 'white', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46154 18.462C6.68591 17.4499 6.68801 15.4885 7.40504 13.2593L4.22653 11.4249C4.06178 11.3322 3.92184 11.2012 3.81862 11.0428C3.7154 10.8844 3.65194 10.7035 3.63365 10.5154C3.62158 10.3684 3.64059 10.2206 3.68945 10.0815C3.88054 9.53565 4.12272 9.00903 4.41276 8.50866C6.83727 4.30971 12.0267 2.76823 16.0045 5.0644C16.3254 5.24994 16.5765 5.53173 16.7585 5.89024C17.3061 6.96788 17.2363 8.74721 16.5953 10.7407L19.7738 12.5758C20.0103 12.7125 20.1895 12.919 20.2872 13.1561C20.3887 13.3986 20.3972 13.6701 20.3109 13.9185C20.1199 14.4644 19.8778 14.991 19.5876 15.4913C17.1631 19.6903 11.9737 21.2318 7.99582 18.9356C7.78804 18.8145 7.60642 18.654 7.46154 18.462ZM15.201 13.848C13.7551 16.3528 11.1499 17.5559 9.38175 16.5348C8.49802 16.0249 7.99094 15.0547 7.88562 13.8996C7.81935 13.1777 7.91073 12.384 8.16462 11.5839C8.31597 11.1069 8.52522 10.6284 8.79376 10.1617L8.79934 10.152C10.2453 7.64794 12.8504 6.44476 14.6186 7.4652C15.0601 7.72048 15.4068 8.08946 15.6579 8.53935C16.3456 9.77532 16.301 11.6188 15.4591 13.3619C15.3817 13.5223 15.2973 13.6806 15.2066 13.8383L15.201 13.848Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgComponent;
